import {
  PlayerChangeHistoryFilterValue,
  PlayerPermissionGroup,
  PlayerTransactionFilterValue,
} from '../../interfaces/ui/ui.interface';
import { formatNumberTwoDecimals } from './two-decimals-global-tables.utils';

export const PLAYER_TABLE_COLUMNS = [
  {
    name: 'players.player.playerId',
    prop: 'accountInfo.playerId',
    width: 150,
  },
  {
    name: 'players.player.username',
    prop: 'personalInfo.username',
    width: 250,
  },
  {
    name: 'players.player.firstName',
    prop: 'personalInfo.firstName',
  },
  {
    name: 'players.player.lastName',
    prop: 'personalInfo.lastName',
  },
  {
    name: 'players.player.documentNumber',
    prop: 'personalInfo.documentNumber',
  },
];

export const PLAYER_TABLE_COLUMNS_ACCOUNT_INFO = [
  {
    name: 'players.player.idUserAffiliate',
    prop: 'accountInfo.agentId.userId',
  },
  {
    name: 'players.player.usernameAgent',
    prop: 'accountInfo.agentId.username',
  },
  {
    name: 'players.player.categoryClient',
    prop: 'accountInfo.category',
  },
  {
    name: 'words.city',
    prop: 'accountInfo.cityId.name',
    width: 150,
  },
  {
    name: 'words.currency',
    prop: 'accountInfo.currencyId.name',
  },
  {
    name: 'players.player.email',
    prop: 'personalInfo.email',
    width: 250,
  },
  {
    name: 'players.player.address',
    prop: 'personalInfo.address',
    width: 250,
  },
  {
    name: 'players.player.mobileNumber',
    prop: 'personalInfo.mobileNumber',
  },
  {
    name: 'players.player.loginAttempts',
    prop: 'verificationAndLocks.loginAttempts',
  },
  {
    name: 'players.player.lastLoginIp',
    prop: 'lastIpAddress',
  },
  {
    name: 'words.language',
    prop: 'accountInfo.languageId.name',
  },
];

export const BLOCKED_PLAYER_TABLE_COLUMNS = [
  {
    name: 'players.blocked.table.playerId',
    prop: 'accountInfo.playerId',
  },
  {
    name: 'players.blocked.table.firstName',
    prop: 'personalInfo.firstName',
  },
  {
    name: 'players.blocked.table.lastName',
    prop: 'personalInfo.lastName',
  },
  {
    name: 'players.blocked.table.userName',
    prop: 'personalInfo.username',
  },
  {
    name: 'players.blocked.table.agentId',
    prop: 'accountInfo.agentId.userId',
  },
  {
    name: 'players.blocked.table.agentUserName',
    prop: 'accountInfo.agentId.username',
  },
];

export const TRANSFERRED_PLAYER_TABLE_COLUMNS = [
  {
    name: 'players.transferred.table.playerId',
    prop: 'playerId.accountInfo.playerId',
  },
  {
    name: 'players.transferred.table.userName',
    prop: 'playerId.personalInfo.username',
  },
  {
    name: 'players.transferred.table.previousAgentId',
    prop: 'prevAgentId.userId',
  },
  {
    name: 'players.transferred.table.previousAgentUserName',
    prop: 'prevAgentId.username',
  },
  {
    name: 'players.transferred.table.currentAgentId',
    prop: 'currAgentId.userId',
  },
  {
    name: 'players.transferred.table.currentAgentUserName',
    prop: 'currAgentId.username',
  },
  {
    name: 'players.transferred.table.transferredBy',
    prop: 'transferredById.username',
  },
];

export const ACTIVE_PLAYER_COLUMNS = [
  {
    name: 'players.activePlayer.playerId',
    prop: 'accountInfo.playerId',
  },
  {
    name: 'players.activePlayer.username',
    prop: 'personalInfo.username',
    width: 250,
  },
  {
    name: 'players.activePlayer.firstName',
    prop: 'personalInfo.firstName',
    width: 250,
  },
  {
    name: 'players.activePlayer.lastName',
    prop: 'personalInfo.lastName',
    width: 250,
  },
  {
    name: 'players.activePlayer.agentId',
    prop: 'accountInfo.agentId.userId',
    width: 200,
  },
  {
    name: 'players.activePlayer.usernameAgent',
    prop: 'accountInfo.agentId.username',
  },
  {
    name: 'words.currency',
    prop: 'accountInfo.currencyId.code',
  },
  {
    name: 'players.activePlayer.balanceWithCurrency',
    prop: 'accountInfo.balance',
    shouldSum: true,
    valueFormatter: formatNumberTwoDecimals,
  },
  {
    name: 'players.activePlayer.mobileNumber',
    prop: 'personalInfo.mobileNumber',
  },
];

export const IS_VERIFIED = [
  { value: true, label: 'players.activePlayer.verifyed' },
  { value: false, label: 'players.activePlayer.notVerifyed' },
];

export const PLAYER_STATE = {
  LOCKED: 0,
  UNLOCKED: 1,
};

export const BLOCK_HISTORY_ACTIONS = [
  { value: 'blocked', label: 'players.blockHistory.blocked' },
  { value: 'unblocked', label: 'players.blockHistory.unblocked' },
];

export const PLAYER_REGISTER_VALIDATIONS = {
  PASSWORD: { MIN_LENGTH: 6, MAX_LENGTH: 20 },
};

export const PLAYER_DEFAULT_STATE = 1;

export const PLAYER_TITLES_SIDEBAR = [
  {
    general: [
      'Player information',
      'Private player information',
      'Player verification',
      'Notes',
      'Image document',
      'Messages',
    ],
  },
  { kpi: ['KPIs Jugador', 'Saldos del jugador', 'Pago'] },
  {
    config: ['Configuración apuestas', 'Historial de límites de clientes'],
  },
];

export const FIDELITY_lEVEL_OPTIONS = [
  { value: 'none', label: 'players.player.none' },
  { value: 'bronze', label: 'players.player.bronze' },
  { value: 'silver', label: 'players.player.silver' },
  { value: 'gold', label: 'players.player.gold' },
  { value: 'vip', label: 'players.player.vip' },
];

export const LOGIN_STATUS = {
  CONNECTED: 'connected',
  DISCONNECT: 'disconnected',
};

export const STATUS_ACOUNT = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const STATUS_ACOUNT_OPTIONS = [
  { value: 1, label: 'players.player.active' },
  { value: 0, label: 'players.player.inactive' },
];

export const AFFILIATE_STATUS = {
  NOT_AFFILIATE: 'not_affiliate',
  PENDING: 'pending',
  AFFILIATE: 'affiliate',
  REJECTED: 'rejected',
};

export const AFFILIATE_STATUS_OPTIONS = [
  { value: AFFILIATE_STATUS.NOT_AFFILIATE, label: 'players.verificationRequest.notAffiliate' },
  { value: AFFILIATE_STATUS.PENDING, label: 'players.verificationRequest.pendingAffiliate' },
  { value: AFFILIATE_STATUS.AFFILIATE, label: 'players.verificationRequest.affiliate' },
  { value: AFFILIATE_STATUS.REJECTED, label: 'players.verificationRequest.rejectedAffiliate' },
];

export const STATUS_PLAYER_OPTIONS = [
  { value: 'temporal', label: 'players.player.temporal' },
  { value: 'permanent', label: 'players.player.permanent' },
  { value: 'disabled', label: 'players.player.disabled' },
  { value: 'closed', label: 'players.player.closed' },
  { value: 'forbidden', label: 'players.player.forbidden' },
  { value: 'locked', label: 'players.player.locked' },
  { value: 'suspended', label: 'players.player.suspended' },
  { value: 'opened', label: 'players.player.opened' },
];

export const ALMRISK_OPTIONS = [
  { value: 'none', label: 'players.player.none' },
  { value: 'low', label: 'players.player.low' },
  { value: 'medium', label: 'players.player.medium' },
  { value: 'high', label: 'players.player.high' },
];

export const EXCLUSION_TYPE_OPTIONS = [
  { value: 'none', label: 'players.player.none' },
  { value: 'inadequate_products', label: 'players.player.inadequateProducts' },
  { value: 'uncompetitive_odds', label: 'players.player.uncompetitiveOdds' },
  { value: 'auto_exclusion', label: 'players.player.autoExclusion' },
  {
    value: 'requests_for_documents_and_verifications',
    label: 'players.player.requestsForDocumentsAndVerifications',
  },
  { value: 'account_limitations', label: 'players.player.accountLimitations' },
  { value: 'no_longer_gamble', label: 'players.player.noLongerGamble' },
  { value: 'poor_user_experience', label: 'players.player.poorUserExperience' },
  {
    value: 'lack_of_desired_payments_method',
    label: 'players.player.lackOfDesiredPaymentsMethod',
  },
  {
    value: 'limited_sportsbook_markets_available',
    label: 'players.player.limitedSportsbookMarketsAvailable',
  },
];

export const AGENT_GROUPS_SPORT_OPTIONS = [
  { value: 'halfSFM', label: 'players.player.halfSFM' },
  { value: 'additional', label: 'players.player.additional' },
  { value: 'agent', label: 'players.player.agent' },
  { value: 'arbitrageBetting', label: 'players.player.arbitrageBetting' },
  { value: 'beforeVIP', label: 'players.player.beforeVIP' },
  { value: 'betshopAgent', label: 'players.player.betshopAgent' },
  { value: 'bonusHunter', label: 'players.player.bonusHunter' },
  { value: 'botArb', label: 'players.player.botArb' },
  { value: 'casino', label: 'players.player.casino' },
  { value: 'corridor', label: 'players.player.corridor' },
  { value: 'highRisk', label: 'players.player.highRisk' },
  { value: 'lateBetting', label: 'players.player.lateBetting' },
  { value: 'lowRisk', label: 'players.player.lowRisk' },
  { value: 'negative', label: 'players.player.negative' },
  { value: 'neutral', label: 'players.player.neutral' },
  { value: 'newUser', label: 'players.player.newUser' },
  { value: 'noBonusUser', label: 'players.player.noBonusUser' },
  { value: 'notPlaying', label: 'players.player.notPlaying' },
  { value: 'review', label: 'players.player.review' },
  { value: 'sfm', label: 'players.player.sfm' },
  { value: 'strong', label: 'players.player.strong' },
  { value: 'strongOpinion', label: 'players.player.strongOpinion' },
  { value: 'testUser', label: 'players.player.testUser' },
  { value: 'valueBet', label: 'players.player.valueBet' },
  { value: 'veryNegative', label: 'players.player.veryNegative' },
  { value: 'vip', label: 'players.player.vip' },
];

export const TAB_DETAIL_OPTIONS = {
  PERSONAL_INFO: 'personalInfo',
  PRIVATE_INFO: 'privateInfo',
  RESTRICTIONS: 'restrictions',
  DOCUMENT_IMAGE: 'documentImage',
  BONUS: 'bonus',
  NOTES: 'notes',
  MESSAGES: 'messages',
  TRANSACTIONS: 'transactions',
  BLOCK_HISTORY: 'blockHistory',
  BANK_INFO: 'bankInfo',
  CHANGE_HISTORY: 'changeHistory',
};

export const TAB_RESOLVE_PENDING_BETS_OPTIONS = {
  BYDATERANGE: 'byDateRange',
  BYBETID: 'byBetId',
  REQUESTSETTLEMENT: 'requestSettlement',
};

export const PLAYER_TABS = {
  CHANGE_PASSWORD: '1',
  MOVE_PLAYER: '2',
  BLOCK_PLAYER: '3',
  NOTES: '4',
};

export const RANGE_DAY_OPTIONS = [
  { value: 1, label: 'players.player.betLimits.oneDay' },
  { value: 7, label: 'players.player.betLimits.oneWeek' },
  { value: 15, label: 'players.player.betLimits.twoWeek' },
  { value: 21, label: 'players.player.betLimits.threeWeek' },
  { value: 30, label: 'players.player.betLimits.oneMonth' },
];

export const BALANCE_FILTER_OPTIONS = [
  {
    value: 'exact',
    label: 'words.exactBalance',
  },
  {
    value: 'min',
    label: 'words.minimumBalance',
  },
  {
    value: 'max',
    label: 'words.maximumBalance',
  },
  {
    value: 'range',
    label: 'words.rangoBalance',
  },
];

export enum PlayerPersonalInternalTab {
  SYSTEM = 'system',
  PERSONAL = 'personal',
  CONTACT = 'contact',
  BANK_INFO = 'bankInfo',
  PRIVATE_INFO = 'privateInfo',
}

export const PLAYER_ACCOUNT_STATE_OPENED = 'opened';

export const PLAYER_PERMISSION_GROUPS: PlayerPermissionGroup[] = [
  {
    key: 'capabilities',
    title: 'players.player.capabilities',
    icon: 'fa fa-user-circle-o',
    summaryTitle: 'players.player.capabilitiesShort',
    summaryNote: 'players.player.capabilitiesNote',
    description: 'players.player.capabilitiesDescription',
    permissions: [
      { control: 'canLogin', label: 'players.player.canLogin' },
      { control: 'canBet', label: 'players.player.canBet' },
      { control: 'canDeposit', label: 'players.player.canDeposit' },
      { control: 'canWithdraw', label: 'players.player.canWithdraw' },
      { control: 'canIncreaseLimit', label: 'players.player.canInCreaseLimit' },
      { control: 'canClaimBonuses', label: 'players.player.canClaimBonuses' },
      { control: 'canUpdateNickname', label: 'players.player.canUpdateNickname' },
    ],
  },
  {
    key: 'pageRestrictions',
    title: 'players.player.restrictionsPage',
    icon: 'fa fa-globe',
    summaryTitle: 'players.player.restrictionsPage',
    summaryNote: 'players.player.pageRestrictionsNote',
    description: 'players.player.pageRestrictionsDescription',
    permissions: [
      { control: 'canConnectToSport', label: 'players.player.canConnectToSport' },
      { control: 'canConnectToCasino', label: 'players.player.canConnectToCasino' },
      { control: 'canConnectToLiveCasino', label: 'players.player.canConnectToLiveCasino' },
      { control: 'canConnectToEsports', label: 'players.player.canConnectToEsports' },
      { control: 'canConnectToVirtual', label: 'players.player.canConnectToVirtual' },
      { control: 'canConnectToPromotions', label: 'players.player.canConnectToPromotions' },
      { control: 'canCashout', label: 'players.player.canCashOut' },
    ],
  },
];

export const PLAYER_TRANSACTION_EXTRA_FILTER_KEYS: readonly (keyof PlayerTransactionFilterValue)[] =
  ['transactionType', 'transactionOrigin', 'operationType', 'registeredBy', 'transactionId'];

export const PLAYER_CHANGE_HISTORY_EXTRA_FILTER_KEYS: readonly (keyof PlayerChangeHistoryFilterValue)[] =
  ['status', 'method', 'ip', 'documentId', 'requestId', 'username', 'role'];
